'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable max-len */
var USER_ADDED = exports.USER_ADDED = 'User successfully added!';
var USER_EDITED = exports.USER_EDITED = 'User successfully modified!';
var USER_DELETED = exports.USER_DELETED = 'User successfully removed!';

var COMPANY_ADDED = exports.COMPANY_ADDED = 'Company successfully added!';
var COMPANY_EDITED = exports.COMPANY_EDITED = 'Company successfully modified!';
var COMPANY_DELETED = exports.COMPANY_DELETED = 'Company successfully removed!';

var REGULATOR_ADDED = exports.REGULATOR_ADDED = 'Regulator successfully added!';
var REGULATOR_EDITED = exports.REGULATOR_EDITED = 'Regulator successfully modified!';
var REGULATOR_DELETED = exports.REGULATOR_DELETED = 'Regulator successfully removed!';

var ACCOUNT_EDITED = exports.ACCOUNT_EDITED = 'Account information successfully saved!';
var ACCOUNT_LOCKOUT_EDITED = exports.ACCOUNT_LOCKOUT_EDITED = 'Account lockout status successfully saved!';

var ADVERSE_EVENT_ATTESTED = exports.ADVERSE_EVENT_ATTESTED = 'Attested successfully!';
var ADVERSE_EVENT_DELETED = exports.ADVERSE_EVENT_DELETED = 'Adverse event(s) successfully removed!';

var USAGE_DATA_UPDATED = exports.USAGE_DATA_UPDATED = 'Shipping data successfully saved!';

var PRODUCT_ADDED = exports.PRODUCT_ADDED = 'Product successfully added!';
var PRODUCT_EDITED = exports.PRODUCT_EDITED = 'Product changes successfully saved!';
var PRODUCT_DELETED = exports.PRODUCT_DELETED = 'Product(s) successfully removed!';
var PRODUCT_DELETE_GUIDANCE = exports.PRODUCT_DELETE_GUIDANCE = 'Member products will be moved to membertest. Once deleted from membertest, the selected product(s) cannot be recovered!';
var PRODUCT_COPIED = exports.PRODUCT_COPIED = 'Product copied successfully! Save the product for changes to take effect.';

var PRODUCT_SIGNATURE_ADDED = exports.PRODUCT_SIGNATURE_ADDED = 'Product signature successfully applied!';
var PRODUCT_SIGNATURE_DELETED = exports.PRODUCT_SIGNATURE_DELETED = 'Product signature successfully removed!';

var PRODUCT_DISCONTINUED_EDITED = exports.PRODUCT_DISCONTINUED_EDITED = 'Product discontinued status successfully saved!';
var DISCONTINUED_PREFERENCE_CHANGED = exports.DISCONTINUED_PREFERENCE_CHANGED = 'Product discontinued preference successfully saved!';
var PRODUCT_DISCONTINUATION_GUIDANCE = exports.PRODUCT_DISCONTINUATION_GUIDANCE = 'Products should only be discontinued if they are no longer being sold or if there has been a formulation change. For other changes, such as label updates or corrections, the product should be unsigned instead. Please contact your account manager if needed.';

var PRODUCT_LABEL_COMMITTED = exports.PRODUCT_LABEL_COMMITTED = 'Product label successfully changed!';
var PRODUCT_LABEL_CHANGED = exports.PRODUCT_LABEL_CHANGED = 'Product label successfully changed! Save the product for changes to take effect.';
var PRODUCT_LABEL_CHANGED_ERROR = exports.PRODUCT_LABEL_CHANGED_ERROR = 'Unable to upload file! Try again in Google Chrome, Firefox, Safari, Edge, or IE10.';

var ADMINISTRATION_ADDED = exports.ADMINISTRATION_ADDED = 'Administration successfully added!';
var ADMINISTRATION_EDITED = exports.ADMINISTRATION_EDITED = 'Administration changes successfully saved!';
var ADMINISTRATION_DELETED = exports.ADMINISTRATION_DELETED = 'Administration successfully removed!';

var PRODUCT_INGREDIENT_ADDED = exports.PRODUCT_INGREDIENT_ADDED = 'Ingredient successfully added!';
var PRODUCT_INGREDIENT_EDITED = exports.PRODUCT_INGREDIENT_EDITED = 'Ingredient changes successfully saved!';
var PRODUCT_INGREDIENT_DELETED = exports.PRODUCT_INGREDIENT_DELETED = 'Ingredient successfully removed!';

var ADVERSE_EVENT_ADDED = exports.ADVERSE_EVENT_ADDED = 'Adverse event successfully added!';
var ADVERSE_EVENT_EDITED = exports.ADVERSE_EVENT_EDITED = 'Adverse event changes successfully saved!';
var ADVERSE_EVENT_CLOSED = exports.ADVERSE_EVENT_CLOSED = 'Adverse event successfully closed!';

var PASSWORD_CHANGED = exports.PASSWORD_CHANGED = 'Password successfully changed!';
var PASSWORD_RESET = exports.PASSWORD_RESET = 'Password successfully reset.';
var FORGOT_PASSWORD_CONFIRMED = exports.FORGOT_PASSWORD_CONFIRMED = 'Please check your email to retrieve your NASC credentials!';

var SYSTEM_INGREDIENT_ADDED = exports.SYSTEM_INGREDIENT_ADDED = 'System ingredient successfully added!';
var SYSTEM_INGREDIENT_EDITED = exports.SYSTEM_INGREDIENT_EDITED = 'System ingredient changes successfully saved!';
var SYSTEM_INGREDIENT_DELETED = exports.SYSTEM_INGREDIENT_DELETED = 'System ingredient successfully removed!';

var USER_INGREDIENT_ADDED = exports.USER_INGREDIENT_ADDED = 'User ingredient successfully added!';
var USER_INGREDIENT_EDITED = exports.USER_INGREDIENT_EDITED = 'User ingredient changes successfully saved!';
var USER_INGREDIENT_DELETED = exports.USER_INGREDIENT_DELETED = 'User ingredient successfully removed!';
var USER_INGREDIENT_DELETE_CONFIRMATION = exports.USER_INGREDIENT_DELETE_CONFIRMATION = 'Once deleted, the selected ingredient(s) cannot be recovered. They will also be removed from any products containing them.';

var CATEGORY_ADDED = exports.CATEGORY_ADDED = 'Category successfully added!';
var CATEGORY_EDITED = exports.CATEGORY_EDITED = 'Category changes successfully saved!';
var CATEGORY_DELETED = exports.CATEGORY_DELETED = 'Category successfully removed!';

var SYSTEM_MESSAGE_CHANGED = exports.SYSTEM_MESSAGE_CHANGED = 'System message changes successfully saved!';
var COMPANY_MESSAGE_CHANGED = exports.COMPANY_MESSAGE_CHANGED = 'Company message changes successfully saved!';

var INGREDIENT_RISK_REPORT_GENERATED = exports.INGREDIENT_RISK_REPORT_GENERATED = 'Ingredient risk report successfully generated!';
/* eslint-enable max-len */


// WEBPACK FOOTER //
// ./common/messages.js